import * as React from 'react';
import '../../Css/Global/Global.css';
import InfoCard from '../Dashboard/InfoCard';
import {Grid} from "@mui/material";
import CountUp from 'react-countup';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import BalanceIcon from '@mui/icons-material/Balance';
import SpedStatusHandler from '../Dashboard/SpedStatusHandler';
import EvolucaoVendasChart from './EvolucaoVendasChart';
import TopChartWithTable from '../../Components/TopChartWithTable';
import EvolucaoIcmsChart from './EvolucaoIcmsChart';
import { useSecaoVendasDrillDown } from '../../Hooks/useSecaoVendasDrillDown';
import SecaoVendasDrillDownModal from '../../Components/SecaoVendasDrillDown/SecaoVendasDrillDownModal';
import { useRegiaoVendasDrillDown } from '../../Hooks/useRegiaoVendasDrillDown';
import RegiaoVendasDrillDownModal from '../../Components/RegiaoVendasDrillDown/RegiaoVendasDrillDownModal';
import { useIcmsDebitosDrillDown } from '../../Hooks/useIcmsDebitosDrillDown';
import IcmsDebitosPeriodoDrillDownModal from '../../Components/IcmsDebitosPeriodoDrillDown/IcmsDebitosPeriodoDrillDownModal';
import { useSecaoDebitosIcmsDrillDown } from '../../Hooks/useSecaoDebitosIcmsDrillDown';
import SecaoDebitosIcmsDrillDownModal from '../../Components/SecaoDebitosIcmsDrillDown/SecaoDebitosIcmsDrillDownModal';
import { useProdutoVendasDrillDown } from '../../Hooks/useProdutoVendasDrillDown';
import ProdutoVendasDrillDownModal from '../../Components/ProdutoVendasDrillDownModal';
import { useProductDrillDown } from '../../Hooks/useProductDrillDown';
import ProductDrillDownModal from '../../Components/ProductDrillDownModal';
import { useCompradorDrillDown } from '../../Hooks/useCompradorDrillDown';
import { CompradorDrillDownModal } from '../../Components/DrillDown/CompradorDrillDownModal';

import { getSafeNumber } from '../../Helpers';
import { EstablishmentStorageUtils } from '../../Storages/establishmentStorage';
import CompetenciaStorageUtils from '../../Storages/competenciaStorage';

import { azulMonocromatico20, verdeMonocromatico20, vermelhoMonocromatico20, laranjaMonocromatico20, amareloMonocromatico20 } from '../../Components/collorPallete'
  
type VendasHistoricoData = {
  periodo: string;
  total_vendas: number;
};

type FornecedorVendasData = {
  nome?: string;
  descricao_secao?: string;
  total: number;
  cod_part?: string;
  cod_item?: string;
};

type SecaoVendasData = {
  nome: string;
  total: number;
  cod_item?: string;
};

const AnalisesVendas: React.FC = () => {

    const [loading, setLoading] = React.useState(true);
    const [loadingEvolucaoVendas, setLoadingEvolucaoVendas] = React.useState(true);
    const [loadingVendasSecao, setLoadingVendasSecao] = React.useState(true);
    const [loadingProdutosMaisVendidos, setLoadingProdutosMaisVendidos] = React.useState(true);
    const [loadingEvolucaoIcms, setLoadingEvolucaoIcms] = React.useState(true);
    const [loadingSecoesMaioresDebitosIcms, setLoadingSecoesMaioresDebitosIcms] = React.useState(true);
    const [loadingProdutosMaioresDebitosIcms, setLoadingProdutosMaioresDebitosIcms] = React.useState(true);
    const [loadingCompradoresMaioresDebitosIcms, setLoadingCompradoresMaioresDebitosIcms] = React.useState(true);
    const [loadingCompradoresMenoresDebitosIcms, setLoadingCompradoresMenoresDebitosIcms] = React.useState(true);
    const [loadingRegioesMaisVendidos, setLoadingRegioesMaisVendidos] = React.useState(true);

    const [spedFiscalIdSelecionado, setSpedFiscalIdSelecionado] = React.useState<number | null>(null);
    
    // Estado para armazenar o establishment_id atual
    const [establishmentId, setEstablishmentId] = React.useState<string | number | null>(null);

    // Hook para drill down de seções de vendas
    const secaoVendasDrillDown = useSecaoVendasDrillDown();
    
    // Hook para drill down de regiões de vendas
    const regiaoVendasDrillDown = useRegiaoVendasDrillDown();

    // Hook para drill down de débitos ICMS
    const icmsDebitosDrillDown = useIcmsDebitosDrillDown(establishmentId);

    // Hook para drill down de seções com débitos ICMS
    const secaoDebitosIcmsDrillDown = useSecaoDebitosIcmsDrillDown();

    // Hook para drill down de produtos vendas
    const produtoVendasDrillDown = useProdutoVendasDrillDown({ spedFiscalId: spedFiscalIdSelecionado });

    // Hook para drill down de produtos com débitos ICMS
    const produtoDebitosIcmsDrillDown = useProductDrillDown();

    // Hook para drill down de compradores
    const compradorDrillDown = useCompradorDrillDown({ spedFiscalId: spedFiscalIdSelecionado });

    // Estado para feedback visual
    const [showSpedAlert, setShowSpedAlert] = React.useState(false);

    // Função para lidar com clique em seção
    const handleSecaoClick = (secaoData: SecaoVendasData) => {
        if (spedFiscalIdSelecionado) {
            secaoVendasDrillDown.openModal(secaoData, spedFiscalIdSelecionado);
        } else {
            setShowSpedAlert(true);
        }
    };

    // Função para lidar com clique em região
    const handleRegiaoClick = (regiaoData: SecaoVendasData) => {
        if (spedFiscalIdSelecionado) {
            regiaoVendasDrillDown.openModal(regiaoData, spedFiscalIdSelecionado);
        } else {
            setShowSpedAlert(true);
        }
    };

    // Função para fechar o alert
    const handleCloseSpedAlert = () => {
        setShowSpedAlert(false);
    };

    // Função para lidar com clique no gráfico de débitos ICMS
    const handleDebitosIcmsClick = (params: { periodo?: string; sped_fiscal_id?: number | string }) => {
        let normalizedSpedId: number | undefined;

        if (Array.isArray(params.sped_fiscal_id)) {
            const firstId = params.sped_fiscal_id.map((value) => Number(value)).find((value) => !Number.isNaN(value) && value > 0);
            if (firstId) {
                normalizedSpedId = firstId;
            }
        } else if (typeof params.sped_fiscal_id === 'string') {
            const firstId = params.sped_fiscal_id.split(',')
                .map((value) => Number(value.trim()))
                .find((value) => !Number.isNaN(value) && value > 0);
            if (firstId) {
                normalizedSpedId = firstId;
            }
        } else if (typeof params.sped_fiscal_id === 'number' && params.sped_fiscal_id > 0) {
            normalizedSpedId = params.sped_fiscal_id;
        }

        if (normalizedSpedId) {
            setSpedFiscalIdSelecionado(normalizedSpedId);
            icmsDebitosDrillDown.openModal({ periodo: params.periodo, sped_fiscal_id: normalizedSpedId });
            return;
        }

        if (spedFiscalIdSelecionado) {
            icmsDebitosDrillDown.openModal({ periodo: params.periodo, sped_fiscal_id: spedFiscalIdSelecionado });
        } else {
            setShowSpedAlert(true);
        }
    };

    // Função para lidar com clique no gráfico de compradores
    const handleCompradorClick = (compradorData: FornecedorVendasData) => {
        if (spedFiscalIdSelecionado) {
            const nome = compradorData.nome || compradorData.descricao_secao;
            compradorDrillDown.handleBarClick({ 
                indexValue: nome,
                cod_part: compradorData.cod_part
            });
        } else {
            setShowSpedAlert(true);
        }
    };

    // Função para lidar com clique em seção com débitos ICMS
    const handleSecaoDebitosIcmsClick = (secaoData: FornecedorVendasData) => {
        if (spedFiscalIdSelecionado) {
            secaoDebitosIcmsDrillDown.openModal({
                nome: secaoData.descricao_secao ?? '',
                total: secaoData.total
            }, spedFiscalIdSelecionado);
        } else {
            setShowSpedAlert(true);
        }
    };

    // Função para lidar com clique em produtos vendas
    const handleProdutoVendasClick = (produtoData: any) => {
        if (spedFiscalIdSelecionado && produtoData.cod_item) {
            produtoVendasDrillDown.openModal(produtoData.nome, produtoData.cod_item, spedFiscalIdSelecionado);
        } else {
            setShowSpedAlert(true);
        }
    };

    // Função para lidar com clique em produtos com débitos ICMS
    const handleProdutoDebitosIcmsClick = (produtoData: any) => {
        if (spedFiscalIdSelecionado && produtoData.cod_item) {
            produtoDebitosIcmsDrillDown.openModal(produtoData.nome, produtoData.cod_item, spedFiscalIdSelecionado, '1');
        } else {
            setShowSpedAlert(true);
        }
    };

    const [totalNfesSaidas, setTotalNfesSaidas] = React.useState<number | null>(null);
    const [totalVendido, setTotalVendido] = React.useState<number | null>(null);
    const [ticketMedio, setTicketMedio] = React.useState<number | null>(null);
    const [evolucaoVendas, setEvolucaoVendas] = React.useState<VendasHistoricoData[]>([]);
    const [topSecoesMaioresDebitos, setTopSecoesMaioresDebitos] = React.useState<FornecedorVendasData[]>([]);
    const [topProdutosMaioresDebitos, setTopProdutosMaioresDebitos] = React.useState<FornecedorVendasData[]>([]);
    const [topCompradoresMaioresDebitos, setTopCompradoresMaioresDebitos] = React.useState<FornecedorVendasData[]>([]);
    const [topCompradoresMenoresDebitos, setTopCompradoresMenoresDebitos] = React.useState<FornecedorVendasData[]>([]);
    const [topSecoesVendas, setTopSecoesVendas] = React.useState<SecaoVendasData[]>([]);
    const [topProdutosVendas, setTopProdutosVendas] = React.useState<SecaoVendasData[]>([]);
    const [topRegioesVendas, setTopRegioesVendas] = React.useState<SecaoVendasData[]>([]);

    // Funções para buscar dados
    const fetchTotalNfesSaidas = async (spedFiscalId: number) => {
        try {
            const totalNfesResponse = await fetch(process.env.REACT_APP_API_URL+'sped-fiscal/total-nfes/'+spedFiscalId);
            const totalNfesData = await totalNfesResponse.json();
            setTotalNfesSaidas(getSafeNumber(totalNfesData, 'total_saida'));
        } catch (e) {
            console.error('Erro ao carregar dados de total de NFEs', e);
        }
    };

    const fetchTicketMedio = async (spedFiscalId: number) => {
        try {
            const ticketMedioResponse = await fetch(process.env.REACT_APP_API_URL+'sped-fiscal/ticket-medio-vendas/'+spedFiscalId);
            const ticketMedioData = await ticketMedioResponse.json();
            setTicketMedio(getSafeNumber(ticketMedioData, 'total'));
        } catch (e) {
            console.error('Erro ao carregar dados de ticket médio', e);
        }
    };

    const fetchTotalVendido = async (spedFiscalId: number) => {
        try {
            const totalVendasResponse = await fetch(process.env.REACT_APP_API_URL+'sped-fiscal/total-vendas/'+spedFiscalId);
            const totalVendasData = await totalVendasResponse.json();
            setTotalVendido(getSafeNumber(totalVendasData, 'total'));
        } catch (e) {
            console.error('Erro ao carregar dados de total vendido', e);
        }
    };

    const fetchEvolucaoVendas = async () => {
        try {
            setLoadingEvolucaoVendas(true);
            
            // Obter establishment_id do localStorage
            const establishmentData = EstablishmentStorageUtils.get();
            const currentEstablishmentId = establishmentData?.establishment_id;
            
            if (!currentEstablishmentId) {
                console.warn('Estabelecimento não selecionado para evolução de vendas');
                setEvolucaoVendas([]);
                return;
            }
            
            const EvolucaoVendasResponse = await fetch(
                process.env.REACT_APP_API_URL + 
                `sped-fiscal/evolucao-vendas?totalMeses=12&establishment_id=${currentEstablishmentId}`
            );
            const dataEvolucaoVendas: VendasHistoricoData[] = await EvolucaoVendasResponse.json();
            setEvolucaoVendas(dataEvolucaoVendas);
        } catch (e) {
            console.error('Erro ao carregar dados de evolução de vendas', e);
        } finally {
            setLoadingEvolucaoVendas(false);
        }
    };

    const fetchTopSecoesVendas = async (spedFiscalId: number) => {
        try {
            setLoadingVendasSecao(true);
            const responseTopSecoesVendas = await fetch(`${process.env.REACT_APP_API_URL}sped-fiscal/top-secoes-vendas?sped_fiscal_id=${spedFiscalId}`);
            
            if (!responseTopSecoesVendas.ok) {
                throw new Error(`HTTP error! status: ${responseTopSecoesVendas.status}`);
            }
            
            const responseData = await responseTopSecoesVendas.json();
            
            // Verificar se os dados são um array ou têm uma propriedade data
            const dataTopSecoesVendas: SecaoVendasData[] = Array.isArray(responseData) 
                ? responseData 
                : (responseData.data || []);
            
            // Log para debug
            console.log('Top Seções Vendas Raw Response:', responseData);
            console.log('Processed Top Seções Vendas:', dataTopSecoesVendas);
            
            setTopSecoesVendas(dataTopSecoesVendas);
        } catch (e) {
            console.error('Erro ao carregar dados de top seções vendas', e);
            // Definir como array vazio para evitar erros de renderização
            setTopSecoesVendas([]);
        } finally {
            setLoadingVendasSecao(false);
        }
    };

    const fetchTopProdutosVendas = async (spedFiscalId: number) => {
        try {
            setLoadingProdutosMaisVendidos(true);
            const responseTopProdutosVendas = await fetch(`${process.env.REACT_APP_API_URL}sped-fiscal/top-produtos-vendas?sped_fiscal_id=${spedFiscalId}`);
            const dataTopProdutosVendas: SecaoVendasData[] = await responseTopProdutosVendas.json();
            setTopProdutosVendas(dataTopProdutosVendas);
        } catch (e) {
            console.error('Erro ao carregar dados de top produtos vendas', e);
        } finally {
            setLoadingProdutosMaisVendidos(false);
        }
    };

    const fetchTopRegioesVendas = async (spedFiscalId: number) => {
        try {
            setLoadingRegioesMaisVendidos(true);
            const responseTopRegioesVendas = await fetch(`${process.env.REACT_APP_API_URL}sped-fiscal/top-regioes-vendas?sped_fiscal_id=${spedFiscalId}`);
            const dataTopRegioesVendas: SecaoVendasData[] = await responseTopRegioesVendas.json();
            setTopRegioesVendas(dataTopRegioesVendas);
        } catch (e) {
            console.error('Erro ao carregar dados de top regiões vendas', e);
        } finally {
            setLoadingRegioesMaisVendidos(false);
        }
    };

    const fetchTopSecoesMaioresDebitos = async (spedFiscalId: number) => {
        try {
            setLoadingSecoesMaioresDebitosIcms(true);
            const responseTopSecoesMaioresDebitos = await fetch(`${process.env.REACT_APP_API_URL}top10-debito-icms-estrutura/${spedFiscalId}`);
            
            if (!responseTopSecoesMaioresDebitos.ok) {
                throw new Error(`HTTP error! status: ${responseTopSecoesMaioresDebitos.status}`);
            }
            
            const responseData = await responseTopSecoesMaioresDebitos.json();
            
            console.log('Top Seções Maiores Débitos Raw Response Type:', typeof responseData);
            console.log('Top Seções Maiores Débitos Raw Response Keys:', Object.keys(responseData));
            console.log('Top Seções Maiores Débitos Raw Response First Item:', responseData[0] || responseData.data?.[0]);
            
            // Verificar se os dados são um array ou têm uma propriedade data
            const dataTopSecoesMaioresDebitos: FornecedorVendasData[] = Array.isArray(responseData) 
                ? responseData 
                : (responseData.data || []);
            
            // Log para debug
            console.log('Top Seções Maiores Débitos Raw Response:', responseData);
            console.log('Processed Top Seções Maiores Débitos:', dataTopSecoesMaioresDebitos);
            
            setTopSecoesMaioresDebitos(dataTopSecoesMaioresDebitos);
        } catch (e) {
            console.error('Erro ao carregar dados de seções maiores débitos ICMS', e);
            // Definir como array vazio para evitar erros de renderização
            setTopSecoesMaioresDebitos([]);
        } finally {
            setLoadingSecoesMaioresDebitosIcms(false);
        }
    };

    const fetchTopProdutosMaioresDebitos = async (spedFiscalId: number) => {
        try {
            setLoadingProdutosMaioresDebitosIcms(true);
            const responseTopProdutosMaioresDebitos = await fetch(`${process.env.REACT_APP_API_URL}sped-fiscal/top-produtos-maiores-debitos?sped_fiscal_id=${spedFiscalId}`);
            const dataTopProdutosMaioresDebitos: FornecedorVendasData[] = await responseTopProdutosMaioresDebitos.json();
            setTopProdutosMaioresDebitos(dataTopProdutosMaioresDebitos);
        } catch (e) {
            console.error('Erro ao carregar dados de produtos maiores débitos ICMS', e);
        } finally {
            setLoadingProdutosMaioresDebitosIcms(false);
        }
    };

    const fetchTopCompradoresMenoresDebitos = async (spedFiscalId: number) => {
        try {
            setLoadingCompradoresMenoresDebitosIcms(true);
            const responseTopCompradoresMenoresDebitos = await fetch(`${process.env.REACT_APP_API_URL}sped-fiscal/top-compradores-menores-debitos?sped_fiscal_id=${spedFiscalId}`);
            const dataTopCompradoresMenoresDebitos: FornecedorVendasData[] = await responseTopCompradoresMenoresDebitos.json();
            setTopCompradoresMenoresDebitos(dataTopCompradoresMenoresDebitos);
        } catch (e) {
            console.error('Erro ao carregar dados de compradores menores débitos ICMS', e);
        } finally {
            setLoadingCompradoresMenoresDebitosIcms(false);
        }
    };

    const fetchTopCompradoresMaioresDebitos = async (spedFiscalId: number) => {
        try {
            setLoadingCompradoresMaioresDebitosIcms(true);
            const responseTopCompradoresMaioresDebitos = await fetch(`${process.env.REACT_APP_API_URL}sped-fiscal/top-compradores-maiores-debitos?sped_fiscal_id=${spedFiscalId}`);
            const dataTopCompradoresMaioresDebitos: FornecedorVendasData[] = await responseTopCompradoresMaioresDebitos.json();
            setTopCompradoresMaioresDebitos(dataTopCompradoresMaioresDebitos);
        } catch (e) {
            console.error('Erro ao carregar dados de compradores maiores débitos ICMS', e);
        } finally {
            setLoadingCompradoresMaioresDebitosIcms(false);
        }
    };

    // Effect para atualizar establishmentId quando página carrega
    React.useEffect(() => {
        const establishmentData = EstablishmentStorageUtils.get();
        if (establishmentData?.establishment_id) {
            setEstablishmentId(establishmentData.establishment_id);
        }
    }, []);

    // Effect para reaplicar o último SPED selecionado após reload
    React.useEffect(() => {
        if (spedFiscalIdSelecionado !== null) {
            return;
        }

        const competenciaData = CompetenciaStorageUtils.get();
        if (competenciaData?.sped_fiscal_id) {
            setSpedFiscalIdSelecionado(competenciaData.sped_fiscal_id);
        }
    }, [spedFiscalIdSelecionado]);

    // Função principal para carregar todos os dados
    const carregarDados = React.useCallback(async (spedFiscalId: number) => {
        if (Number(spedFiscalId) > 0) {
            // Dados que não precisam de loading
            await Promise.all([
                fetchTotalNfesSaidas(spedFiscalId),
                fetchTicketMedio(spedFiscalId),
                fetchTotalVendido(spedFiscalId),
                fetchEvolucaoVendas(), // Agora usa establishment_id internamente
                fetchTopSecoesVendas(spedFiscalId),
                fetchTopProdutosVendas(spedFiscalId),
                fetchTopRegioesVendas(spedFiscalId),
                fetchTopSecoesMaioresDebitos(spedFiscalId),
                fetchTopProdutosMaioresDebitos(spedFiscalId),
                fetchTopCompradoresMenoresDebitos(spedFiscalId),
                fetchTopCompradoresMaioresDebitos(spedFiscalId)
            ]);
        }
    }, []);

    // Effect adicional para recarregar evolução quando estabelecimento mudar
    React.useEffect(() => {
        if (establishmentId && spedFiscalIdSelecionado) {
            fetchEvolucaoVendas();
        }
    }, [establishmentId]);

    // Effect principal que chama todas as funções
    React.useEffect(() => {
        if (spedFiscalIdSelecionado) {
            carregarDados(spedFiscalIdSelecionado);
        }
    }, [spedFiscalIdSelecionado, carregarDados]);


    return (
        <>
            <Grid container spacing={0.5}>

            <SpedStatusHandler
                    onSpedFiscalIdChange={(id, dataInicio, dataFim, establishmentId) => {
                        setSpedFiscalIdSelecionado(id);
                        setEstablishmentId(establishmentId ? Number(establishmentId) : null);
                    }}
                />

              <InfoCard title="Análise de Vendas" icon={<AddShoppingCartIcon />} iconColor="info" size={12} />

              <InfoCard
                    title="Vendas realizadas"
                    value={<CountUp end={totalNfesSaidas || 0} duration={0.5} separator="." preserveValue />}
                    icon={<DocumentScannerIcon />}
                    iconColor="info"
                    
                />

              <InfoCard title="Ticket Médio" value={
                    <CountUp
                        end={ticketMedio || 0}
                        duration={0.5}
                        separator="."
                        decimals={2}
                        decimal=","
                        prefix="R$ "
                        preserveValue
                    />
                }
                    icon={<MonetizationOnIcon />}
                    iconColor="info"
                    
                />
                
                <InfoCard
                  title="Total Vendido"
                  value={
                    <CountUp
                        end={totalVendido || 0}
                        duration={0.5}
                        separator="."
                        decimals={2}
                        decimal=","
                        prefix="R$ "
                        preserveValue
                    />
                  }
                  icon={<MonetizationOnIcon />}
                  iconColor="error"
                  formatAsCurrency={true} size={6}
                  
                />

                  <Grid item xs={12}>
                    <EvolucaoVendasChart 
                      data={evolucaoVendas} 
                      loading={loadingEvolucaoVendas}
                      establishmentId={establishmentId}
                      onMissingEstablishment={() => setShowSpedAlert(true)}
                    />
                  </Grid>

                <Grid item xs={12} md={6} lg={6}>
                  <TopChartWithTable 
                    data={topSecoesVendas} 
                    loading={loadingVendasSecao} 
                    title={'Top 10 Seções por Venda'}
                    color={azulMonocromatico20}
                    tableTitle="Demais Seções por Venda"
                    onItemClick={handleSecaoClick}
                  />
                </Grid>

                <Grid item xs={12} md={6} lg={6}>
                  <TopChartWithTable 
                    data={topProdutosVendas} 
                    loading={loadingProdutosMaisVendidos} 
                    title={'Top 10 Produtos Mais Vendidos (Valor)'}
                    color={verdeMonocromatico20}
                    tableTitle="Demais Produtos Vendidos"
                    onItemClick={handleProdutoVendasClick}
                  />
                </Grid>

                <Grid item xs={12} md={12} lg={12}>
                  <TopChartWithTable 
                    data={topRegioesVendas} 
                    loading={loadingRegioesMaisVendidos} 
                    title={'Top 10 Regiões com Maiores Vendas (Valor)'}
                    color={amareloMonocromatico20}
                    tableTitle="Demais Regiões com Vendas"
                    onItemClick={handleRegiaoClick}
                  />
                </Grid>

                <InfoCard title="Análise de ICMS" icon={<BalanceIcon />} iconColor="info" size={12} />              

                <Grid item xs={12} md={12} lg={12}>
                    {establishmentId != null &&
                        <EvolucaoIcmsChart
                            endpoint={"icms-evolucao-vendas/12?establishment_id="+establishmentId}
                            title={"Evolução dos Débitos de ICMS (Últimos 12 meses)"}
                            onBarClick={handleDebitosIcmsClick}
                        />
                    }
                </Grid>

                <Grid item xs={12} md={6} lg={6}>
                  <TopChartWithTable 
                    data={topSecoesMaioresDebitos} 
                    loading={loadingSecoesMaioresDebitosIcms} 
                    title={'Top 10 Seções com Maiores Débitos de ICMS'}
                    color={laranjaMonocromatico20}
                    tableTitle="Demais Seções com Débitos ICMS"
                    onItemClick={handleSecaoDebitosIcmsClick}
                    nameKey="descricao_secao"
                  />
                </Grid>

                <Grid item xs={12} md={6} lg={6}>
                  <TopChartWithTable 
                    data={topProdutosMaioresDebitos} 
                    loading={loadingProdutosMaioresDebitosIcms} 
                    title={'Top 10 Produtos com Maiores Débitos de ICMS'}
                    color={vermelhoMonocromatico20}
                    tableTitle="Demais Produtos com Débitos ICMS"
                    onItemClick={handleProdutoDebitosIcmsClick}
                  />
                </Grid>

                <Grid item xs={12} md={6} lg={6}>
                  <TopChartWithTable 
                    data={topCompradoresMaioresDebitos} 
                    loading={loadingCompradoresMaioresDebitosIcms} 
                    title={'Top 10 Compradores com Maiores Débitos de ICMS'}
                    color={laranjaMonocromatico20}
                    tableTitle="Demais Compradores com Maiores Débitos"
                    onItemClick={handleCompradorClick}
                  />
                </Grid>

                <Grid item xs={12} md={6} lg={6}>
                  <TopChartWithTable 
                    data={topCompradoresMenoresDebitos} 
                    loading={loadingCompradoresMenoresDebitosIcms} 
                    title={'Top 10 Compradores com Menores Débitos de ICMS'}
                    color={azulMonocromatico20}
                    tableTitle="Demais Compradores com Menores Débitos"
                    onItemClick={handleCompradorClick}
                  />
                </Grid>
              
            </Grid>

            {/* Modal de Drill Down de Seções de Vendas */}
            <SecaoVendasDrillDownModal
                isOpen={secaoVendasDrillDown.isModalOpen}
                onClose={secaoVendasDrillDown.closeModal}
                data={secaoVendasDrillDown.drillDownData}
                loading={secaoVendasDrillDown.loading}
                selectedSecao={secaoVendasDrillDown.selectedSecao}
                error={secaoVendasDrillDown.error}
                onRetry={secaoVendasDrillDown.retry}
            />

            {/* Modal de Drill Down de Regiões de Vendas */}
            <RegiaoVendasDrillDownModal
                isOpen={regiaoVendasDrillDown.isModalOpen}
                onClose={regiaoVendasDrillDown.closeModal}
                data={regiaoVendasDrillDown.drillDownData}
                loading={regiaoVendasDrillDown.loading}
                selectedRegiao={regiaoVendasDrillDown.selectedRegiao}
                error={regiaoVendasDrillDown.error}
                onRetry={regiaoVendasDrillDown.retry}
            />

            {/* Modal de Drill Down de Débitos ICMS */}
            <IcmsDebitosPeriodoDrillDownModal
                isOpen={icmsDebitosDrillDown.isModalOpen}
                onClose={icmsDebitosDrillDown.closeModal}
                data={icmsDebitosDrillDown.data}
                loading={icmsDebitosDrillDown.loading}
                selectedPeriodo={icmsDebitosDrillDown.selectedItem}
                error={icmsDebitosDrillDown.error}
                onRetry={icmsDebitosDrillDown.retry}
            />

            {/* Modal de Drill Down de Seções com Débitos ICMS */}
            <SecaoDebitosIcmsDrillDownModal
                isOpen={secaoDebitosIcmsDrillDown.isModalOpen}
                onClose={secaoDebitosIcmsDrillDown.closeModal}
                data={secaoDebitosIcmsDrillDown.drillDownData}
                loading={secaoDebitosIcmsDrillDown.loading}
                selectedSecao={secaoDebitosIcmsDrillDown.selectedSecao}
                error={secaoDebitosIcmsDrillDown.error}
                onRetry={secaoDebitosIcmsDrillDown.retry}
            />

            {/* Modal de Drill Down de Produtos Vendas */}
            <ProdutoVendasDrillDownModal
                open={produtoVendasDrillDown.isModalOpen}
                onClose={produtoVendasDrillDown.closeModal}
                data={produtoVendasDrillDown.drillDownData}
                loading={produtoVendasDrillDown.loading}
                selectedProduto={produtoVendasDrillDown.selectedProduto}
                error={produtoVendasDrillDown.error}
                onRetry={produtoVendasDrillDown.retry}
            />

            {/* Modal de Drill Down de Produtos com Débitos ICMS */}
            <ProductDrillDownModal
                open={produtoDebitosIcmsDrillDown.isModalOpen}
                onClose={produtoDebitosIcmsDrillDown.closeModal}
                data={produtoDebitosIcmsDrillDown.drillDownData}
                loading={produtoDebitosIcmsDrillDown.loading}
                productName={produtoDebitosIcmsDrillDown.selectedProductName}
            />

            {/* Modal de Drill Down de Compradores */}
            <CompradorDrillDownModal
                open={compradorDrillDown.drillLevel === 'detail'}
                onClose={compradorDrillDown.handleDrillUp}
                data={compradorDrillDown.drillDownData}
                loading={compradorDrillDown.loading}
                error={compradorDrillDown.error}
                selectedComprador={compradorDrillDown.selectedComprador}
                onRetry={compradorDrillDown.retry}
            />

        </>
      );
      
}


export default AnalisesVendas;

